export const defaultStyle = {
    width: "100%",
    control: {
        backgroundColor: "#fff",
        fontSize: 14,
        fontWeight: "normal",
    },
    highlighter: {
        overflow: "hidden",
    },
    input: {
        margin: 0,
        overflow: "auto",
        border: "none",
        outline: "none"
    },
    "&multiLine": {
        control: {
        },
        highlighter: {
            padding: 0
        },
        input: {
            padding: 0,
            minHeight: 3,
            outline: 0,
            border: 0
        }
    },
    suggestions: {
        bottom: "0",
        top: "unset",
        zIndex: 9,
        border: "1px solid #ddd",
        list: {
            backgroundColor: "white",
            fontSize: 13,
            "max-height": "var(--ck-mention-list-max-height)",
            "overflow-y": "auto",
            "overflow-x": "hidden",
            "overscroll-behavior": "contain",
            "display": "flex",
            "flex-direction": "column"
        },
        item: {
            padding: "5px 15px",
            "&focused": {
                backgroundColor: "var(--itsm-bg-btn)",
                color: "#fff"
            }
        }
    }
};

export const defaultMentionStyle = {
    backgroundColor: "rgba(111, 181, 84, 0.19)",
};